import React from "react"
import PropTypes from "prop-types"
import { Box, Button, Flex } from "@chakra-ui/react"
import FormControl from "./form-control"
import MultiFormControl from "./multi-form-control"

const styles = {
  button: {
    bg: "#129459",
    color: "white",
    padding: "16px 32px",
    height: "56px",
  },
  form: {
    bg: "white",
    position: "relative",
    width: "100%",
    minWidth: { base: "100%", md: "432px", lg: "432px" },
    px: "24px",
    border: "1px solid #DCE0E5",
    borderRadius: "4px",
  },
}

const handleMap = (list, handle) => {
  return list.map(item => {
    if (Array.isArray(item)) {
      return handleMap(item, handle)
    }
    return handle(item)
  })
}

const isEvery = (list, handle) =>
  list.every(item =>
    Array.isArray(item) ? isEvery(item, handle) : handle(item)
  )

const Form = ({ fields, submitText, onSubmit, loading }) => {
  const [_fields, setFields] = React.useState([])
  const handleOnChange = React.useCallback((id, value) => {
    setFields(prev => handleMap(prev, p => (p.id === id ? { ...p, value } : p)))
  }, [])
  const handleSubmit = React.useCallback(
    e => {
      if (!loading) {
        let payload
        setFields(prev => {
          const result = handleMap(prev, p => ({
            ...p,
            hint: p.validate(p.value),
          }))
          const isValid = isEvery(result, r => !r.hint)
          if (isValid) {
            payload = result
          }
          return result
        })
        if (payload) {
          onSubmit(payload)
        }
      }
    },
    [onSubmit, loading]
  )
  React.useEffect(() => {
    setFields(fields)
  }, [fields])

  return (
    <Box sx={styles.form} as="form" onClick={e => e.preventDefault()}>
      <Flex
        sx={{
          flexDirection: "column",
          margin: "0 auto",
          justifyContent: "space-between",
        }}
      >
        {_fields.map(field =>
          Array.isArray(field) ? (
            <MultiFormControl
              key={field[0].id}
              fields={field}
              onChange={handleOnChange}
            />
          ) : (
            <FormControl
              key={field.id}
              name={field.name}
              label={field.label}
              type={field.fieldType}
              value={field.value}
              required={field.required}
              hint={field.hint}
              id={field.id}
              onChange={handleOnChange}
            />
          )
        )}
      </Flex>
      <Flex sx={{ margin: "0 auto", my: "40px" }}>
        <Button
          sx={styles.button}
          _hover={styles.button}
          _active={styles.button}
          _focus={styles.button}
          onClick={handleSubmit}
          isLoading={loading}
        >
          {submitText}
        </Button>
      </Flex>
    </Box>
  )
}

Form.propTypes = {
  fields: PropTypes.array,
  submitText: PropTypes.string,
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
}

Form.defaultProps = {
  onSubmit: () => {},
}

export default Form
